/**
 * @requires ./frc.js
 */

frc.pages.locationDetail = {
 	"data": {},
 	"init": function(){
 		var self = frc.pages.locationDetail;
 		frc.page = self; /*
 		var coords = jQuery(".locations-map-embed").attr("data-coordinates");
 		var statusIndicationMessage = jQuery(".locations-map-embed").attr("data-status-indication-message");
 		if(coords){
 			coords = coords.split(",");
 			if(coords.length===2){
			   self.map = new frcMap({
			        container: 'locations-map-canvas', // ID of div where map will be output - Default is 'locations-map-canvas'.
			        center: coords, // Array containing latitude and longitude for central point of map. Default is [38.973731, -109.210078].
			        listings: [{
			        	"location": {
			        		"coordinates": coords,
			        		"statusIndicationMessage": statusIndicationMessage
			        	}
			        }],
			        zoom: {
			        	mobile: 14,
			        	desktop: 15
			        }, // Default zoom level of map on load
			        zoomControl: true, // Provide zoom in/out controls to the user
			    });
 			}
 		}*/

		// Fire off event for analytics
		$(frc).trigger("locationdetailspageloaded", {
			"locationId": frcContext.locationId
		});
/*
		$(window).on("markerclicked", function(evt, mkr) {
			var $mapContainer = $('#'+ self.map.options.container);
			if ($mapContainer.attr('data-location-address')) {
				var address = encodeURIComponent($mapContainer.attr('data-location-address'));
            	window.open('https://www.google.com/maps/place/'+ address);
			}
		});
*/
 	}
}